/* ============================================================
   BUNON — PDP behaviour
   Gallery + zoom lens, colourway swatches, haat size selector,
   qty/bundle pricing, delivery progress, sticky mobile ATC,
   accordion, size-guide modal
   ============================================================ */
(function () {
  'use strict';

  var $ = function (sel, root) { return (root || document).querySelector(sel); };
  var $$ = function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };

  /* Shopify passes the product data; we read the Liquid-rendered
     data attributes from the section root element. */
  var section = $('.bunon-pdp-section');
  if (!section) return;

  /* Liquid passes prices in cents (Shopify's native variant.price scale,
     e.g. 99000 for ৳990.00); convert once here so the rest of this file
     can work in whole currency units. */
  function cents(raw, fallback) { return parseInt(raw, 10) / 100 || fallback; }
  var UNIT_PRICE   = section.dataset.unitPrice    ? cents(section.dataset.unitPrice)    : 895;
  var COMPARE_PRICE= section.dataset.comparePrice ? cents(section.dataset.comparePrice) : 1150;
  var FREE_SHIP_AT = section.dataset.freeShipAt   ? cents(section.dataset.freeShipAt)   : 2000;

  /* Bundle prices are derived from this product's own unit price (not a fixed
     BDT amount), so they stay correct no matter which product/price this
     section renders on. */
  var BUNDLE2_DISCOUNT_PCT = section.dataset.bundle2Discount ? parseFloat(section.dataset.bundle2Discount) : 5;
  var BUNDLE3_DISCOUNT_PCT = section.dataset.bundle3Discount ? parseFloat(section.dataset.bundle3Discount) : 10;
  var BUNDLE_2 = Math.round(UNIT_PRICE * 2 * (1 - BUNDLE2_DISCOUNT_PCT / 100));
  var BUNDLE_3 = Math.round(UNIT_PRICE * 3 * (1 - BUNDLE3_DISCOUNT_PCT / 100));

  var state = { colour: section.dataset.colourKey || 'indigo', qty: 1, size: '5' };

  /* ---------- Bangla numerals ---------- */
  var BN = { 0:'০',1:'১',2:'২',3:'৩',4:'৪',5:'৫',6:'৬',7:'৭',8:'৮',9:'৯' };
  function bn(num) {
    return num.toLocaleString('en-IN').replace(/\d/g, function (d) { return BN[d]; });
  }
  function taka(num) { return '৳' + bn(num); }

  /* ---------- Gallery slides + thumbs ---------- */
  var main   = $('.bunon-gallery__main');
  var slides = $$('.bunon-g-slide', main);
  var thumbs = $$('.bunon-g-thumb');

  /* ---------- Zoom lens ---------- */
  var lens = $('.bunon-zoom-lens', main);
  var ZOOM = 2.4;

  function activeZoomImage() {
    var activeSlide = slides.filter(function (s) { return s.classList.contains('active'); })[0] || slides[0];
    var img = activeSlide && activeSlide.querySelector('img[data-zoom-src]');
    return img ? img.getAttribute('data-zoom-src') : null;
  }

  function updateLensImage() {
    if (!lens) return;
    var src = activeZoomImage();
    if (src) {
      lens.style.backgroundImage = 'url("' + src + '")';
      lens.classList.add('has-image');
    } else {
      lens.style.backgroundImage = '';
      lens.classList.remove('has-image');
    }
  }

  function showSlide(i) {
    slides.forEach(function (s, j) { s.classList.toggle('active', i === j); });
    thumbs.forEach(function (t, j) {
      t.classList.toggle('active', i === j);
      t.setAttribute('aria-pressed', String(i === j));
    });
    updateLensImage();
  }
  thumbs.forEach(function (t, i) {
    t.addEventListener('click', function () { showSlide(i); });
  });

  if (main && lens) {
    function positionLens(clientX, clientY) {
      var r = main.getBoundingClientRect();
      main.classList.add('zooming');
      var x = clientX - r.left;
      var y = clientY - r.top;
      lens.style.left = x + 'px';
      lens.style.top  = y + 'px';
      if (lens.classList.contains('has-image')) {
        var lw = lens.offsetWidth || r.width * 0.46;
        var lh = lens.offsetHeight || lw;
        lens.style.backgroundSize = (r.width * ZOOM) + 'px ' + (r.height * ZOOM) + 'px';
        lens.style.backgroundPosition =
          '-' + (x * ZOOM - lw / 2) + 'px -' + (y * ZOOM - lh / 2) + 'px';
      }
    }

    main.addEventListener('mousemove', function (e) {
      positionLens(e.clientX, e.clientY);
    });
    main.addEventListener('mouseleave', function () {
      main.classList.remove('zooming');
    });

    main.addEventListener('touchstart', function (e) {
      if (e.touches.length === 1) {
        positionLens(e.touches[0].clientX, e.touches[0].clientY);
      }
    }, { passive: true });
    main.addEventListener('touchmove', function (e) {
      if (e.touches.length === 1) {
        positionLens(e.touches[0].clientX, e.touches[0].clientY);
      }
    }, { passive: true });
    main.addEventListener('touchend', function () {
      main.classList.remove('zooming');
    });

    updateLensImage();
  }

  /* ---------- Colourway swatches ---------- */
  var COLOURS = ['indigo', 'madder', 'forest', 'char'];
  var NAMES = {
    indigo: { bn: 'নীলাম্বরী নীল', en: 'Nilambari Indigo' },
    madder: { bn: 'মজিঠা লাল',     en: 'Majitha Madder'  },
    forest: { bn: 'বনানী সবুজ',    en: 'Bonani Forest'   },
    char:   { bn: 'কাজল ধূসর',     en: 'Kajol Charcoal'  }
  };

  function applyColour(c) {
    state.colour = c;
    /* swap fabric class on every [data-colour-surface] element */
    $$('[data-colour-surface]').forEach(function (el) {
      COLOURS.forEach(function (k) { el.classList.remove('bunon-fabric--' + k); });
      el.classList.add('bunon-fabric--' + c);
    });
    /* update swatch aria state */
    $$('.bunon-swatch').forEach(function (s) {
      s.setAttribute('aria-pressed', String(s.dataset.colour === c));
    });
    /* update label — prefer this product's real colour name over the
       decorative fallback dictionary, which only covers 4 placeholder tones */
    var lang = document.documentElement.getAttribute('data-lang') || 'bn';
    var out = $('[data-sel-colour]');
    var realLabel = c === section.dataset.colourKey ? section.dataset.colourLabel : null;
    if (out) out.textContent = realLabel || (NAMES[c] && NAMES[c][lang]) || (NAMES[c] && NAMES[c].bn) || c;
  }

  $$('.bunon-swatch').forEach(function (s) {
    s.addEventListener('click', function () { applyColour(s.dataset.colour); });
  });

  /* ---------- Size selector ---------- */
  $$('.bunon-size-btn').forEach(function (b) {
    b.addEventListener('click', function () {
      if (b.disabled) return;
      state.size = b.dataset.size;
      $$('.bunon-size-btn').forEach(function (x) {
        x.setAttribute('aria-pressed', String(x === b));
      });
      var out = $('[data-sel-size]');
      if (out) out.textContent = b.dataset.sizeLabel || b.dataset.size;

      var variantId = b.dataset.variantId;
      if (variantId) {
        var idInput = $('input[name="id"]', atcForm || document);
        if (idInput) idInput.value = variantId;
        var url = window.location.pathname + '?variant=' + variantId;
        window.history.replaceState({}, '', url);
      }
    });
  });

  /* ---------- Qty + bundle pricing + delivery progress ---------- */
  function lineTotal(qty) {
    if (qty >= 3) {
      var trios = Math.floor(qty / 3), rem = qty % 3;
      return trios * BUNDLE_3 + (rem === 2 ? BUNDLE_2 : rem * UNIT_PRICE);
    }
    if (qty === 2) return BUNDLE_2;
    return qty * UNIT_PRICE;
  }

  function render() {
    var total = lineTotal(state.qty);

    var qtyOut = $('[data-qty-out]');
    if (qtyOut) qtyOut.textContent = bn(state.qty);

    var totalOut = $('[data-total]');
    if (totalOut) totalOut.textContent = taka(total);

    var stickyPrice = $('[data-sticky-price]');
    if (stickyPrice) stickyPrice.textContent = taka(total);

    var saved = state.qty * UNIT_PRICE - total;
    var nudge = $('[data-bundle-nudge]');
    if (nudge) {
      var freeShip = total >= FREE_SHIP_AT || state.qty >= 3;
      nudge.classList.toggle('hit', state.qty >= 2);
      if (state.qty >= 3) {
        nudge.innerHTML = '✓ বান্ডেল প্রাইস চালু — আপনি বাঁচালেন <b>' + taka(saved) + '</b> + <b>ফ্রি ডেলিভারি</b>';
      } else if (state.qty === 2) {
        nudge.innerHTML = '✓ জোড়া অফার চালু — বাঁচালেন <b>' + taka(saved) + '</b>। আর ১টি নিলে <b>ফ্রি ডেলিভারি</b>';
      } else {
        nudge.innerHTML = '৩টি কিনলে <b>' + taka(BUNDLE_3) + '</b> + <b>ফ্রি ডেলিভারি</b>';
      }
    }

    var bar = $('[data-ship-bar]');
    var lbl = $('[data-ship-label]');
    if (bar && lbl) {
      var free = total >= FREE_SHIP_AT || state.qty >= 3;
      var pct  = Math.min(100, Math.round(total / FREE_SHIP_AT * 100));
      bar.style.width = (free ? 100 : pct) + '%';
      if (free) {
        lbl.innerHTML = '🎉 <b>ফ্রি ডেলিভারি আনলকড</b> — Free delivery unlocked';
      } else {
        lbl.innerHTML = 'ফ্রি ডেলিভারির জন্য আর ' + taka(FREE_SHIP_AT - total);
      }
    }
  }

  var minus = $('[data-qty-minus]');
  var plus  = $('[data-qty-plus]');
  minus && minus.addEventListener('click', function () { state.qty = Math.max(1, state.qty - 1); render(); });
  plus  && plus.addEventListener('click',  function () { state.qty = Math.min(10, state.qty + 1); render(); });

  /* ---------- Add to cart → shared BunonCart path + open drawer ----------
     Delegated off document rather than bound to the form node: the theme
     editor re-renders this section on every setting change, and a handler
     bound to the old node would be lost the moment a merchant touches a
     setting — leaving the button to do a native POST and navigate away. */
  function isBuyForm(el) {
    if (!el || !el.getAttribute) return false;
    /* getAttribute, not .id — <input name="id"> shadows the form's own
       id property, so el.id returns that input element. */
    if (el.getAttribute('id') === 'bunon-product-form') return true;
    return (el.getAttribute('action') || '').indexOf('/cart/add') > -1;
  }

  document.addEventListener('submit', function (e) {
    var atcForm = e.target;
    if (!isBuyForm(atcForm)) return;
    {
      e.preventDefault();
      var qtyInput = atcForm.querySelector('[name="quantity"]');
      if (qtyInput) qtyInput.value = state.qty;
      var idInput = atcForm.querySelector('[name="id"]');
      var btn = atcForm.querySelector('[type="submit"]');
      if (btn) { btn.disabled = true; btn.style.opacity = '.6'; }

      var done = function () {
        if (btn) { btn.disabled = false; btn.style.opacity = ''; }
      };

      /* Any properties[...] inputs the buy form carries (the pre-order block
         adds one holding the promised ship date) travel with the line. */
      var props = {};
      $$('input[name^="properties["]', atcForm).forEach(function (input) {
        var key = input.name.slice('properties['.length, -1);
        if (key && input.value) props[key] = input.value;
      });

      if (window.BunonCart && idInput) {
        window.BunonCart.add(idInput.value, state.qty, { openDrawer: true, properties: props })
          .catch(function (err) {
            if (window.bunonToast) window.bunonToast(err.message || 'কার্টে যোগ করা যায়নি');
          })
          .then(done, done);
        return;
      }

      /* Fallback: post the form itself if the shared helper is unavailable. */
      fetch(window.Shopify.routes.root + 'cart/add.js', { method: 'POST', body: new FormData(atcForm) })
        .then(function () { window.location.href = window.Shopify.routes.root + 'cart'; })
        .catch(done);
    }
  });

  /* ---------- Sticky mobile ATC ---------- */
  var sticky  = $('.bunon-sticky-atc');
  var mainCta = $('#bunon-main-atc');
  if (sticky && mainCta) {
    document.body.classList.add('bunon-has-sticky-atc');
    function checkSticky() {
      var out = mainCta.getBoundingClientRect().bottom < 0;
      sticky.classList.toggle('show', out);
      sticky.setAttribute('aria-hidden', String(!out));
    }
    window.addEventListener('scroll', checkSticky, { passive: true });
    checkSticky();
  }

  /* ---------- Accordion ---------- */
  $$('.bunon-acc__btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var item = btn.closest('.bunon-acc__item');
      if (!item) return;
      var isOpen = item.classList.contains('open');
      /* close all */
      $$('.bunon-acc__item').forEach(function (i) { i.classList.remove('open'); });
      /* open clicked if it was closed */
      if (!isOpen) item.classList.add('open');
    });
  });

  /* ---------- Language toggle re-renders ---------- */
  document.addEventListener('bunonLangChange', function () {
    applyColour(state.colour);
    render();
  });

  /* ---------- Suppress auto-injected COD buttons in product form ----------
     Third-party COD apps should only render inside their dedicated App Block. */
  function pruneFormInjections() {
    var form = document.getElementById('bunon-product-form');
    if (!form) return;
    var badInjections = form.querySelectorAll('#rsi_buy_now_button, .rsi-app-block-container, [data-releasit-button], [id*="rsi_buy"], [class*="rsi-app"]');
    badInjections.forEach(function (node) {
      node.style.setProperty('display', 'none', 'important');
    });
  }
  pruneFormInjections();
  document.addEventListener('DOMContentLoaded', pruneFormInjections);
  window.addEventListener('load', pruneFormInjections);
  document.addEventListener('shopify:section:load', pruneFormInjections);
  if (window.MutationObserver) {
    var formObserver = new MutationObserver(pruneFormInjections);
    var targetForm = document.getElementById('bunon-product-form');
    if (targetForm) {
      formObserver.observe(targetForm, { childList: true, subtree: true });
    }
  }

  /* ---------- Init ---------- */
  applyColour(state.colour);
  render();

})();
